import { AudioManager } from '../utilities/AudioManager';

export class DiceBoard extends Phaser.GameObjects.Container {
  private readonly screenWidth;
  private readonly screenHeight;

  scene;
  winningNumbers: any;
  dice1: any;
  dice2: any;
  dice3: any;
  dice4: any;
  dice5: any;
  rotateTween: any;
  timer1: any;
  repeatCount: any;
  ballPositionX: any;
  ballPositionY: any;

  constructor(scene, screenWidth, screenHeight, drawResult) {
    super(scene);
    this.repeatCount = 0;
    this.scene = scene;
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    this.ballPositionX = 115;
    this.ballPositionY = this.screenHeight / 1.9;
    if (!drawResult || drawResult.length !== 6) {
      this.showErrorMessage('Invalid draw results');
      return;
    }

    const winningNumbers = drawResult.slice(0, 5);
    this.winningNumbers = winningNumbers;

    this.dice1 = this.scene.add.sprite(this.screenWidth / 4.5, this.screenHeight + 60, 'dice1').setScale(0.5);
    this.dice2 = this.scene.add.sprite(this.screenWidth / 3.5, this.screenHeight + 60, 'dice2').setScale(0.5);
    this.dice3 = this.scene.add.sprite(this.screenWidth / 2, this.screenHeight + 60, 'dice3').setScale(0.5);
    this.dice4 = this.scene.add.sprite(this.screenWidth / 1.5, this.screenHeight + 60, 'dice4').setScale(0.5);
    this.dice5 = this.scene.add.sprite(this.screenWidth / 1.15, this.screenHeight + 60, 'dice5').setScale(0.5);

    this.scene.tweens.add({
      targets: [this.dice1],
      props: {
        angle: 360,
        x: this.ballPositionX,
        y: this.ballPositionY
      },
      ease: Phaser.Math.Easing.Quadratic,
      duration: 500,
      delay: 250,
      yoyo: false
    });

    // rotate dice from bottom to top
    this.timer1 = this.scene.time.addEvent({
      delay: 70,
      callback: this.rotateDice,
      ease: Phaser.Math.Easing.Quadratic,
      callbackScope: this
    });
  }

  playDiceSound() {
    AudioManager.getInstance().playSoundEffect(this.scene, 'RollingDices');
  }

  removeDice() {
    this.scene.tweens.add({
      targets: [this.dice1, this.dice2, this.dice3, this.dice4, this.dice5],
      props: { angle: 360, x: this.screenWidth / 2, y: this.screenHeight + 100 },
      ease: Phaser.Math.Easing.Quadratic,
      duration: 300,
      delay: 150,
      yoyo: false
    });
  }

  resetDice(dice, resultId) {
    dice.angle = 0;
    dice.setTexture('dice' + this.winningNumbers[resultId]);
  }

  showErrorMessage(message) {
    console.log(message);
  }

  updateDiceAngle(dice: any) {
    let newAngle = 35;
    if (this.repeatCount > 185) {
      newAngle = dice.angle > 0 ? 80 : 22;
    }
    dice.angle += newAngle;
    dice.setTexture('dice' + Math.floor(Math.random() * 5 + 1));
  }

  rotateIndividualDice(dice, nextDice, index, count) {
    this.updateDiceAngle(dice);
    if (this.repeatCount === count) {
      const ballLeftMargin = 130;
      this.ballPositionX = index + 1 > 0 ? this.ballPositionX + ballLeftMargin : this.ballPositionX;
      this.ballPositionY = (index + 2) % 2 === 0 ? this.screenHeight / 1.75 : this.screenHeight / 1.9;
      // this.resetDice(dice, index);
      this.scene.tweens.add({
        targets: [nextDice],
        props: {
          angle: 360,
          x: this.ballPositionX,
          y: this.ballPositionY
        },
        ease: Phaser.Math.Easing.Quadratic,
        duration: 500,
        yoyo: false
      });
      this.playDiceSound();
    }
    this.repeatCount += 1;
  }

  getDice(diceId) {
    switch (diceId) {
      case 0:
        return this.dice1;
      case 1:
        return this.dice2;
      case 2:
        return this.dice3;
      case 3:
        return this.dice4;
      case 4:
        return this.dice5;
      default:
        return;
    }
  }
  rotateDice() {
    this.playDiceSound();
    this.rotateTween = this.scene.tweens.addCounter({
      duration: 50,
      repeat: 850,
      onUpdate: () => {
        if (!this.scene.time.paused && this.repeatCount >= 1 && this.repeatCount <= 350) {
          this.updateDiceAngle(this.dice1);
        }
        this.diceRoll();
        this.repeatCount += 1;
      }
    });
  }

  private removeIndividualDices() {
    //remove dice after showing winning numbers from top to down
    for (let i = 0; i < 5; i++) {
      this.scene.tweens.add({
        targets: this.getDice(i),
        props: {
          x: 115 + i * 130,
          y: this.screenHeight / 2 - 50
        },
        ease: 'Power2',
        duration: 500,
        delay: i * 1000,
        yoyo: true,
        onComplete: () => {
          this.getDice(i).setVisible(false);
          if (i === 4) {
            this.scene.tweens.killAll();
            this.scene.time.removeEvent(this.timer1);
            this.moveToNextScene();
          }
        }
      });
    }
  }

  private diceRoll() {
    for (let i = 0; i < 4; i++) {
      if (!this.scene.time.paused && this.repeatCount > 100 + i * 70 && this.repeatCount <= 400 + i * 70) {
        if (this.repeatCount === 101 + i * 70) {
          this.ballPositionX = i + 1 > 0 ? this.ballPositionX + 130 : this.ballPositionX;
          this.ballPositionY = (i + 2) % 2 === 0 ? this.screenHeight / 1.75 : this.screenHeight / 1.9;
          this.scene.tweens.add({
            targets: this.getDice(i + 1),
            props: {
              angle: 360,
              x: this.ballPositionX,
              y: this.ballPositionY
            },
            ease: Phaser.Math.Easing.Quadratic,
            duration: 500,
            yoyo: false
          });
          this.playDiceSound();
        }
        this.updateDiceAngle(this.getDice(i + 1));
        if (this.repeatCount === 350) {
          this.resetDice(this.dice1, 0);
        } else if (this.repeatCount === 400 + i * 70) {
          this.resetDice(this.getDice(i + 1), i + 1);
          if (i === 0 || i === 1) {
            this.playDiceSound();
          }
          if (i === 3) {
            setTimeout(() => {
              this.removeIndividualDices();
            }, 2500);
          }
        }
      }
    }
  }

  moveToNextScene() {
    this.scene.time.addEvent({
      delay: 1000,
      callback: () => {
        this.scene.scene.stop('RollDiceScene');
        this.scene.scene.start('MultiplierScene');
      }
    });
  }

  pauseTimer() {
    this.scene.time.paused = true;
    this.rotateTween?.pause();
    this.scene.tweens.pauseAll();
    AudioManager.getInstance().pauseSoundEffect(this.scene);
  }

  resumeTimer() {
    this.scene.time.paused = false;
    this.rotateTween?.resume();
    this.scene.tweens.resumeAll();
    AudioManager.getInstance().resumeSoundEffect(this.scene);
  }
}
